import {WithNextSlot} from "@components/Booking/useNextAvailable";
import {Location} from "@components/Booking/LocationSelection/types";
import {LocationName} from "./LocationName";
import {FullAddress} from "./FullAddress";
import {TimeInfo, TimeInfoLoading} from "./TimeInfo";
import React from "react";
import {WithDistance} from "@components/Booking/LocationSelection/useWithDistanceFromUser";

const LocationInfo = ({
  disabled,
  location,
  slotsLoading,
}: {
  disabled: boolean;
  location: WithDistance<WithNextSlot<Location>>;
  slotsLoading: boolean;
}) => {
  const locationName = location?.name;
  const address = location?.locationAddress?.address;
  const nextSlotTime = location?.nextSlot?.time;
  return (
    <div className="flex flex-col grow basis-0 items-start">
      {locationName && <LocationName disabled={disabled} location={location} />}
      {address && <FullAddress address={address} disabled={disabled} />}
      {slotsLoading ? (
        <TimeInfoLoading />
      ) : (
        <TimeInfo location={location} nextSlotTime={nextSlotTime} />
      )}
    </div>
  );
};

export default React.memo(LocationInfo);
